<template>
    <div>
        <page-title>编辑应用信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="标识" prop="name">
                    <el-input v-model="form.name" placeholder="应用唯一标识"/>
                </el-form-item>
                <el-form-item label="名称" prop="display_name">
                    <el-input v-model="form.display_name" placeholder="应用名称"/>
                </el-form-item>
                <el-form-item label="平台最低版本" prop="platform_version">
                    <el-input v-model="form.platform_version" placeholder="安装应用要求平台的最低版本"/>
                </el-form-item>
                <el-form-item label="价格" prop="price">
                    <el-input v-model="form.price"/>
                </el-form-item>
                <el-form-item label="是否开放" prop="is_open">
                    <el-switch v-model="form.is_open" :active-value="1" :inactive-value="0"/>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="form.sort"/>
                </el-form-item>
                <el-form-item label="图标" prop="pic_url">
                    <app-upload v-model="form.pic_url" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="简介" prop="desc">
                    <el-input v-model="form.desc"/>
                </el-form-item>
                <el-form-item label="详情" prop="content">
                    <br>
                    <quill-editor :options="editorOption" v-model="form.content"></quill-editor>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<script>
import baseUrl from '@/base-url'
import axios from '@/axios'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import {quillRedefine} from 'vue-quill-editor-upload'

export default {
    components: {
        quillEditor
    },
    data() {
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            rules: {
                name: [
                    {required: true, message: '请填应用标识。'}
                ],
                display_name: [
                    {required: true, message: '请填应用名称。'}
                ],
                pic_url: [
                    {required: true, message: '请填应用图标。'}
                ],
                price: [
                    {required: true, message: '请填应用价格。'}
                ],
                platform_version: [
                    {required: true, message: '请填平台版本。'}
                ],
                cat_name: [
                    {required: true, message: '请选择应用分类。'}
                ]
            },
            form: {
                id: null,
                name: '',
                display_name: '',
                pic_url: '',
                price: '',
                desc: '',
                content: '',
                platform_version: '',
                is_open: 0,
                sort: 1000,
                cat_name: ''
            },
            editorOption: {}
        }
    },
    created() {
        this.editorOption = quillRedefine(
            {
                // 图片上传的设置
                uploadConfig: {
                    // 必填参数 图片上传地址
                    action: baseUrl + '/admin/upload/file',
                    header: (xhr, formData) => {
                        xhr.setRequestHeader('Access-Token', this.$store.state.user.access_token)
                    },
                    name: 'file',
                    // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
                    // 你必须把返回的数据中所包含的图片地址 return 回去
                    res: (response) => {
                        // 这里切记要return回你的图片地址
                        if (response.code === 0) {
                            return response.data.url
                        }
                    }
                }
            }
        )
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/app/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form = e.data.data
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: this.form.id ? 'admin/app/update' : 'admin/app/create',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/app/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
